<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="关键词">
        <el-input
          v-model="searchModel.keyword"
          placeholder="请输入姓名、证书名称等"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>

      <el-form-item prop="state" label="证书状态">
        <el-select v-model="searchModel.state" clearable placeholder="请选择" @change="getTableData(true)">
          <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" @onRefresh="getTableData()">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="empName" label="姓名" align="center" width="120"></el-table-column>
        <el-table-column prop="certName" label="证书名称" header-align="center"></el-table-column>
        <el-table-column prop="endTime" label="证书到期日期" align="center" width="120"></el-table-column>
        <el-table-column prop="state" label="证书状态" align="center" width="120">
          <template v-slot="{ row }">
            <el-tag v-if="row.state == -2" type="danger">已过期</el-tag>
            <el-tag v-else-if="row.state == -1" type="danger">90天内过期</el-tag>
            <el-tag v-else type="success">正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="关联文件" align="center">
          <template v-slot="{ row }">
            <div v-for="(file, inex) in row.fileList" :key="inex">
              <el-link type="primary" :underline="false" :href="$imgUrl + file.filePath" target="_blank">
                {{ file.fileName }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>

        <el-table-column label="操作" width="120" align="center">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link type="danger" @click="handleDelete(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 新增/编辑 弹窗 -->
    <CertificateEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import CertificateEdit from './components/CertificateEdit';

import { getUserCertList, deleteUserCert } from '@/api/archives';

export default {
  components: { TableHeader, CertificateEdit },
  data() {
    return {
      refTable: null,
      certTypeOptions: [
        {
          label: '培训证书',
          value: 0
        },
        {
          label: '资格证书',
          value: 1
        }
      ],
      stateOptions: [
        {
          label: '正常',
          value: 0
        },
        {
          label: '90天内过期',
          value: -1
        },
        {
          label: '已过期',
          value: -2
        }
      ],
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        certType: '',
        state: '',
        keyword: ''
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      // 弹窗
      activeRowId: null,
      editVisible: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const { data } = await getUserCertList({ ...this.searchModel });
      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteUserCert({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  .warning-row {
    .el-table__cell {
      position: relative;
    }
  }
  .logo-box {
    padding-left: 12px;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 24px;
    }
  }
}
</style>
